// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"673":"49d2b991","1210":"1087c751","2808":"65eef570","5782":"90f32124"}[chunkId] + ".chunk.css";
};